import { createFileRoute } from "@tanstack/react-router";
import { DocumentsPage } from "../screens/DocumentsScreen";

export const Route = createFileRoute("/_app/documents/")({
  component: DocumentsPage,
});
